const StorageKeys = {
  ID_TOKEN: "ID_TOKEN",
  FIRST_COME: "FIRST_COME"
};

export default StorageKeys;
